import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  createInsuranceExpiryReminder,
  getInsuranceExpiryReminders,
  type CreateInsuranceExpiryReminderParams,
} from '../endpoints/insuranceExpiryReminder.ts';

const INSURANCE_EXPIRY_REMINDER_QUERY_NAMESPACE = 'insurance-expiry-reminders';

const useInsuranceExpiryReminders = (accountId: string) =>
  useQuery({
    queryKey: [INSURANCE_EXPIRY_REMINDER_QUERY_NAMESPACE, accountId],
    queryFn: () => getInsuranceExpiryReminders(accountId),
  });

const useCreateInsuranceExpiryReminder = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: CreateInsuranceExpiryReminderParams) =>
      createInsuranceExpiryReminder(params),
    onSuccess: (_, { accountId }) =>
      queryClient.invalidateQueries({
        queryKey: [INSURANCE_EXPIRY_REMINDER_QUERY_NAMESPACE, accountId],
      }),
  });
};

export { useCreateInsuranceExpiryReminder, useInsuranceExpiryReminders };
